<template>
    <div>
        <v-row>
            <v-col cols="12" class="d-flex justify-center text-h6">
                Créer un nouvel utilisateur
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-form>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field-filled
                                label="Prénom"
                                v-model="firstname"
                            >
                            </v-text-field-filled>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field-filled
                                label="Nom"
                                v-model="lastname"
                            >
                            </v-text-field-filled>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field-filled
                                label="Email"
                                v-model="email"
                            >
                            </v-text-field-filled>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field-filled
                                label="Numéro de téléphone"
                                v-model="phoneNumber"
                            >
                            </v-text-field-filled>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-btn block @Click="createUser()">Créer l'utilisateur</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">

import CREATE_FAKE_USER from "@/graphql/user/CreateFakeUser.gql";

import { Component, Vue, toNative, Prop, Emit, Watch } from "vue-facing-decorator";
import { DialogAction } from "@/services/dialogAction";

@Component
export class CreateFakeUser extends Vue {
    @Prop({default: false}) readonly isBack: boolean;
    @Prop() readonly companyId: string;
    @Prop({ default: null }) actions: DialogAction;

    email: string = "";
    firstname: string = "";
    lastname: string = "";
    phoneNumber: string = "";

    @Emit("back")
    goBack() {
        return ;
    }

    @Emit("addUser")
    async createUser() {
        const result = await this.$apollo.mutate({
            mutation: CREATE_FAKE_USER,
            variables: {
                email: this.email,
                firstname: this.firstname,
                lastname: this.lastname,
                phoneNumber: this.phoneNumber,
                companyId: this.companyId
            }
        })
        const user = {
            email: this.email,
            firstname: this.firstname,
            lastname: this.lastname,
            phoneNumber: this.phoneNumber,
            id: result.data.createUser.id
        }
        return user
    }

    @Watch("actions", {immediate: true})
    initPreviousAction() {
        this.actions.previous = this.goBack;
    }
}

export default toNative(CreateFakeUser);

</script>
